import React, { useEffect } from "react";
import "./RoadMap.css";
import { FaChild, FaFemale, FaHeartbeat, FaSmile } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

const RoadMap = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out-cubic",
      once: true,
      offset: 100,
    });
    AOS.refresh();
  }, []);

  const cards = [
    {
      icon: <FaChild />,
      title: "Child Focused",
      highlight: "Building the Future Generation",
      highlightClass: "highlight-orange",
      items: [
        "Support education for children in underserved rural areas",
        "Increase awareness and access to essential learning opportunities",
        "Promote joyful, activity-based learning environments",
        "Ensure proper teaching support, infrastructure, and learning facilities",
        "Provide technology-enabled tools to expand learning reach",
        "Offer continuous guidance, mentoring, and emotional support",
      ],
      iconClass: "icon-orange",
    },
    {
      icon: <FaFemale />,
      title: "Women Focused",
      highlight: "Towards an Empowered Society",
      highlightClass: "highlight-pink",
      items: [
        "Equip women with employable skills and training",
        "Help them rise above discrimination and social barriers",
        "Promote financial independence for long-term stability",
        "Create awareness about rights, responsibilities, and leadership roles",
        "Use technology as a tool to strengthen women empowerment initiatives",
      ],
      iconClass: "icon-pink",
    },
    {
      icon: <FaHeartbeat />,
      title: "Preventive HealthCare",
      highlight: "Healthy Communities, Brighter Lives",
      highlightClass: "highlight-green",
      items: [
        "Facilitate access to affordable and reliable healthcare services",
        "Organize health awareness and early-detection campaigns",
        "Provide basic health check-ups and screening resources",
        "Enable regular medical consultations for timely interventions",
        "Collaborate with doctors and medical researchers for improved care",
      ],
      iconClass: "icon-green",
    },
    {
      icon: <FaSmile />,
      title: "Happiness",
      highlight: "Celebrating the Spirit of Life",
      highlightClass: "highlight-blue",
      items: [
        "Spread joy through cultural programs and community festivals",
        "Encourage free expression and sharing through meaningful activities",
      ],
      iconClass: "icon-blue",
    },
  ];

  return (
    <div className="roadmap-section">
      <h1
        className="roadmap-title"
        data-aos="fade-down"
        data-aos-delay="100"
        data-aos-duration="1200"
      >
        Our Road Map
      </h1>
      <div
        className="roadmap-underline"
        data-aos="fade-right"
        data-aos-delay="200"
        data-aos-duration="1200"
      ></div>

      <div className="roadmap-grid">
        {cards.map((card, index) => (
          <div
            className="roadmap-card"
            key={index}
            data-aos="fade-up"
            data-aos-delay={300 + index * 150}
            data-aos-duration="1000"
            data-aos-offset="150"
          >
            <div className={`icon-box ${card.iconClass}`} data-aos="zoom-in" data-aos-delay={400 + index * 150}>
              {card.icon}
            </div>

            <h2 data-aos="fade-right" data-aos-delay={450 + index * 150}>
              {card.title}
            </h2>

            <ul>
              {card.items.map((item, i) => (
                <li
                  key={i}
                  data-aos="fade-left"
                  data-aos-delay={500 + i * 100 + index * 150}
                >
                  {item}
                </li>
              ))}
            </ul>

            <p
              className={`highlight ${card.highlightClass}`}
              data-aos="fade-up"
              data-aos-delay={600 + index * 150}
            >
              {card.highlight}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoadMap;
